<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${coverWidth} ${coverHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="coverWidth" :height="coverHeight" />
      <g ref="main">
        <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/old/main-480w.jpg`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/old/main-768w.jpg`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/old/main-1280w.jpg`" media="(max-width: 1280px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/old/main.jpg`" />
          </picture>
        </foreignObject>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue-1"
      :width="0.3"
      :tx="0.525" :ty="0.2"
      :fontSize="20"
      :className="`minion`"
      :bg="`transparent`">
      Max and his mind weren’t as they once were in his younger years. We knew
      it was time when we didn’t see him out there with the cattle anymore.
    </SceneDialogue>
    <SceneDialogue
      ref="dialogue-2"
      :width="0.22"
      :tx="1" :ty="0.5"
      :fontSize="18"
      :className="`minion`"
      :bg="`transparent`">
      Our family decided to move him to a nursing home in Tucson. We visited
      him a lot. My brother Lawrence and his family took him driving around
      Tucson.
    </SceneDialogue>
    <SceneDialogue
      ref="dialogue-3"
      :width="0.22"
      :tx="1" :ty="0.75"
      :fontSize="18"
      :className="`minion`">
      He passed on July 10, 1997. He was buried out in Tsegi.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/old/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    coverWidth: 4175,
    coverHeight: 3006,
    showContent: false,
  }),
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d1 = this.$refs["dialogue-1"].$el
    const d2 = this.$refs["dialogue-2"].$el
    const d3 = this.$refs["dialogue-3"].$el
    TweenLite.set(main, {opacity: 0})
    TweenLite.set(d1, {opacity: 0})
    TweenLite.set(d2, {opacity: 0})
    TweenLite.set(d3, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 2, {opacity: 1}))
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}), "-=1")
    this.tl.add(TweenLite.to(d2, 1, {opacity: 1}), "-=0.5")
    this.tl.add(TweenLite.to(d3, 1, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()}
  },
  props: ["slide"]
}
</script>
